import '../layout/theme';
import React from 'react';
import { createRoot } from 'react-dom/client';
import CollectionContainer from './components/collections/CollectionContainer';
import CollectionCuratedContainer from './components/collections/CollectionCuratedContainer';
import { buildSearchFilters } from '@jbhi-fi/utils/src/buildAlgoliaSearchFilters/buildAlgoliaSearchFilters';
import { ContentfulMetafieldCollection } from '@jbhi-fi/apis/src/contentful/types';
import { BaseContentProvider } from './components/stack/components/BaseContentProvider/BaseContentProvider';
import { DefaultLayout, drawDefaultLayout } from './components/layout/DefaultLayout';

const collectionModule = () => {
  const collection: ContentfulMetafieldCollection | undefined = window.Jbhifi.collection;
  const collectionRoot = document.querySelector('#collection-container');
  const contentfulImageQuality = window.Jbhifi.contentfulSettings?.collectionContentfulImageQuality;

  if (!collection || !collectionRoot) {
    drawDefaultLayout();
    return;
  }

  if (collection && collection.template) {
    const collectionBody = document.querySelector('.template-collection');
    collectionBody?.classList.add(`collection-${collection.template}`);
  }

  const searchFilters = buildSearchFilters(collection.filters ?? '');

  const ThemeWrapper = ({ children }: { children: React.ReactNode }) => (
    <BaseContentProvider
      shopifyProductActionsProviderProps={{ attachPageType: 'collections' }}
      configProviderProps={{ contentfulImageQuality }}
    >
      <DefaultLayout>{children}</DefaultLayout>
    </BaseContentProvider>
  );

  const root = createRoot(collectionRoot);

  switch (collection.template) {
    case 'curated':
      root.render(
        <ThemeWrapper>
          <CollectionCuratedContainer {...collection} searchFilters={searchFilters} />
        </ThemeWrapper>
      );
      break;
    case 'enhanced':
    case 'catalogue':
    case 'merchstudio':
    default:
      root.render(
        <ThemeWrapper>
          <CollectionContainer {...collection} searchFilters={searchFilters} />
        </ThemeWrapper>
      );
      break;
  }
};

collectionModule();

export default collectionModule;
